// @ts-nocheck — mixin methods are composed onto BackendService at runtime; instance API is typed via adminBackendServiceInterface.ts.
import type BaseBackendService from '../BaseBackendService';
import Document from '../../models/Document';
export const adminBackendServiceInvestorMixin = {
  addInvestorDocument(
    investorId: string,
    payload: { title: string; location: string; categoryId?: string },
  ): Promise<void> {
    return this.authApiMutateAuthed<void>(
      `investors/${investorId}/documents`,
      'POST',
      payload,
      () => undefined,
    );
  },

  addGenericInvestorDocument(
    fundOpportunityId: string,
    payload: { title: string; location: string; categoryId?: string },
  ): Promise<void> {
    return this.authApiMutateAuthed<void>(
      `fundOpportunities/${fundOpportunityId}/documents`,
      'POST',
      payload,
      () => undefined,
    );
  },

  updateInvestorDocumentCategory(
    investorId: string,
    documentId: string,
    categoryId: string,
  ): Promise<Document> {
    return this.authApiMutateAuthed(
      `investors/${investorId}/documents/${documentId}`,
      'PATCH',
      { categoryId },
      (json) => json?.data as Document,
    );
  },

  updateGenericInvestorDocumentCategory(
    fundOpportunityId: string,
    documentId: string,
    categoryId: string,
  ): Promise<Document> {
    return this.authApiMutateAuthed(
      `fundOpportunities/${fundOpportunityId}/documents/${documentId}`,
      'PATCH',
      { categoryId },
      (json) => json?.data as Document,
    );
  },

  deleteInvestorGenericDocument(fundOpportunityId: string, documentId: string): Promise<void> {
    return this.authApiDeleteVoid(`fundOpportunities/${fundOpportunityId}/documents/${documentId}`);
  },

  deleteInvestorDocument(investorId: string, documentId: string): Promise<void> {
    return this.authApiDeleteVoid(`investors/${investorId}/documents/${documentId}`);
  },

  deleteInvestor(investorId: string): Promise<void> {
    return this.authApiDeleteVoid(`investors/${investorId}/candidate`);
  },

  getInvestorDocuments(investorId: string): Promise<Document[]> {
    return this.authApiGetAuthed(
      `investors/${investorId}/documents`,
      'Network error while fetching investor documents',
      (json) => json.data as Document[],
    );
  },

  getGenericInvestorDocuments(fundOpportunityId: string): Promise<Document[]> {
    return this.authApiGetAuthed(
      `fundOpportunities/${fundOpportunityId}/documents`,
      'Network error while fetching fund opportunity documents',
      (json) => json.data as Document[],
    );
  },
} satisfies ThisType<BaseBackendService>;
